
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/quienes-somos",
      function () {
        return require("private-next-pages/es/quienes-somos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/quienes-somos"])
      });
    }
  